export const DistanceMeasures = [
    {
        value: "KM",
        label: "Kilometres",
    },
    {
        value: "MILE",
        label: "Miles",
    },
];
//# sourceMappingURL=distances.js.map